import { styled } from '@mui/system';

export const PinMapContainer = styled('div')(({ theme }) => ({
	marginTop: 15,
	marginBottom: 15,
	'@media (max-width: 600px)': {
		marginBottom: 50
	}
}));
